var Slide = (function(){

    function Slide($el) {

        // console.log("Slide", $el);
        this.$el = $el;
        this.timelines = [];
        this.events = [];
        this.mouseX = 0;
        this.mouseY = 0;
    }

    Slide.prototype.constructor = Slide;

    /* ================================================================= */

    Slide.prototype.beforeDestroy = function() {
        // To override, I mean if you want to
    };

    Slide.prototype.onMouseMove = function(x, y) {
        this.mouseX = x;
        this.mouseY = y;
    };

    Slide.prototype.onMouseDown = function() {
        this.mousePressed = true;
    };

    Slide.prototype.onMouseUp = function() {
        this.mousePressed = false;
    };

    Slide.prototype.update = function() {
        // To override if you want to use requestAnimationFrame
    };

    Slide.prototype.resize = function(width, height) {
        // To override if you want to use requestAnimationFrame
    };

    /* ================================================================= */

    Slide.prototype.addTimeline = function(tl) {
        this.timelines.push(tl);
    };

    Slide.prototype.addEvent = function(targetSelector, eventType, callback) {
        this.$el.find(targetSelector).off(eventType).on(eventType, callback);
        this.events.push(targetSelector);
    };

    Slide.prototype.removeEvent = function(targetSelector, eventType, callback) {
        if(this.events.indexOf(targetSelector) < 0) return;
        this.$el.find(targetSelector).off(eventType, callback);
        this.events.splice(this.events.indexOf(targetSelector), 1);
    };

    Slide.prototype.destroy = function() {
        this.beforeDestroy();
        for (var i = this.timelines.length - 1; i >= 0; i--) {
            this.timelines[i].kill();
        }
        for (var i = this.events.length - 1; i >= 0; i--) {
            $(this.events[i]).off('click mouseover mouseout mousemove mouseenter mouseleave');
        }
    };

    return Slide;
})();